export const Styles = {
    dark: {

        body: "#1a202c",
        text: "white",
        highlight: "#2a202c",
        imageHighlight: "#07beb8",
        compImgHighlight: "#07beb8",
        minHeight: "100vh"

    },
    light: {
        body: "#EDF9FE",
        text: "#001C55",
        highlight: "#A6E1FA",
        dark: "#00072D",
        secondaryText: "#7F8DAA",
        imageHighlight: "#0E6BA8",
        compImgHighlight: "#E6E6E6",
        jacketColor: "#0A2472",
        headerColor: "#0E6BA877",
    }

}
